import React, { useRef } from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import Button from "components/Elements/Button/Button.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";
import { useUploaderInput } from "components/Pages/Home/Helpers/useUploaderInput.js";
import UploaderSendComponent from "./FormsUploaderSendComponent.js";
import FormsUploaderProgress from "./FormsUploaderProgress.js";

const UploaderFooter = ({ embedDesign, filesCount, filesProgress }) => {
  const { getTextByKey } = useContent();
  const { uploaderGetFiles, getUploading } = useUploader();

  const filesRef = useRef();
  const folderRef = useRef();

  const { handleAddFiles, handleAddFolders } = useUploaderInput({
    filesRef,
    folderRef,
  });

  return (
    <div
      className="jm-form-uploader-footer"
      style={
        embedDesign
          ? {
              backgroundColor: embedDesign.backgroundColor,
            }
          : {}
      }
    >
      {!getUploading() ? (
        <div className="jm-form-uploader-buttons">
          {uploaderGetFiles().length === 0 ? (
            <div className="buttons-section">
              <Button onClick={handleAddFiles} blank>
                {getTextByKey("add-files-uploader")}
                <Icon name="file-alt-solid" blue />
              </Button>
              <Button onClick={handleAddFolders} blank>
                {getTextByKey("add-folder-uploader")}
                <Icon name="folder-alt-solid" blue />
              </Button>
            </div>
          ) : (
            <>
              <div className="buttons-section">
                <div className="add-buttons-container-files-exist">
                  <Tooltip tooltipTextKey="add-files-uploader">
                    <Icon name={"home/add_files"} onClick={handleAddFiles} />
                  </Tooltip>
                  <Tooltip tooltipTextKey="add-folder-uploader">
                    <Icon name={"home/add_folder"} onClick={handleAddFolders} />
                  </Tooltip>
                </div>
                <div className="flex-spacer"></div>
                <UploaderSendComponent embedDesign={embedDesign} />
              </div>
              <div className="text-info">
                {getTextByKey("use-drag-and-drop-mobile")}
              </div>
            </>
          )}
        </div>
      ) : (
        <FormsUploaderProgress {...{ filesCount, filesProgress }} />
      )}

      <div className="hidden-inputs">
        <input type="file" className="files-input" ref={filesRef} multiple />
        <input
          type="file"
          className="folders-input"
          aria-hidden="true"
          webkitdirectory=""
          directory=""
          multiple
          ref={folderRef}
        ></input>
      </div>
    </div>
  );
};

export default UploaderFooter;
